import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { Product_Sub_Family_Name_Enum } from '@kheops/graphql';
import useSortedProductFamiliesMap, { ProductFamily } from '../../hooks/useSortedProductFamiliesMap';
import { DefaultValues } from './ProductSearchBar';
import { AvailabilityFilterValues } from './ProductAvailabilityFilter';

interface UseSearchProductsOutput {
  productFamilyMap: ProductFamily[];
  selectedProductFamilyMap: ProductFamily[];
  query: string;
  availabilityFilter: AvailabilityFilterValues;
  setQuery: Dispatch<SetStateAction<string>>;
  setAvailabilityFilter: Dispatch<SetStateAction<AvailabilityFilterValues>>;
  setProductFamilies :Dispatch<SetStateAction<Product_Sub_Family_Name_Enum[]>>;
}

export interface UseSearchProductsProps {
  productFamiliesOptions: Product_Sub_Family_Name_Enum[];
  onChange: (productFamilies: Product_Sub_Family_Name_Enum[], query: string, availability: AvailabilityFilterValues) => void;
  defaultValues?: Partial<DefaultValues>;
}

export default function useSearchProducts({ onChange, productFamiliesOptions, defaultValues }: UseSearchProductsProps): UseSearchProductsOutput {
  const productFamilyMap = useSortedProductFamiliesMap(productFamiliesOptions);
  const [productFamilies, setProductFamilies] = useState<Product_Sub_Family_Name_Enum[]>(defaultValues?.productFamilies || []);
  const selectedProductFamilyMap = useSortedProductFamiliesMap(productFamilies);
  const [query, setQuery] = useState(defaultValues?.query || '');
  const [availabilityFilter, setAvailabilityFilter] = useState<AvailabilityFilterValues>(defaultValues?.availability || 'ALL');

  useEffect((): void => {
    onChange(productFamilies, query, availabilityFilter);
  }, [productFamilies, query, availabilityFilter]);

  return {
    productFamilyMap,
    selectedProductFamilyMap,
    query,
    availabilityFilter,
    setQuery,
    setProductFamilies,
    setAvailabilityFilter,
  };
}
